<script lang="ts">
    import {Link} from "svelte-routing";
    import ShareRose from "./ShareRose.svelte";
    import {Rose} from "../rose";
    import NavigationButton from "../shared/NavigationButton.svelte";

    export let rose: Rose;
</script>
<svelte:head>
    <title>Roses UPC - Detalls</title>
</svelte:head>

<div id="image-info-container">
    <img class="selected-image" src="{rose.src}" alt="Rosa"/>
    <div id="selected-image-info">
        <p>Inspirada en l'estil de l'artista
            <Link to="/galeria?artist={rose.artist}">
                {rose.artist}
            </Link>
            amb la descripció "{rose.description}"
        </p>
        <ShareRose rose="{rose}"/>
    </div>
</div>

<div>
    <br>
    <p class="details-info-text">
        Les imatges s’han creat mitjançant models generatius de <i>deep learning</i>, que consten d’una arquitectura de
        xarxes neuronals que permeten produir una imatge a partir d’un text.
    </p>
    <p class="details-info-text">
        El model s’inicia a partir de la imatge d’una rosa i l’algorisme la va modificant per a que s’aproximi a l’estil
        de l’artista i al text introduït tal i com es pot veure al vídeo de la generació de la rosa.
    </p>

    <video class="selected-image" src="{rose.videoSrc}" preload muted autoplay controls></video>

    <div class="row-buttons">
        <NavigationButton to="informacio" text="Vols saber-ne més?"></NavigationButton>
        <NavigationButton to="galeria" text="Anar a la galeria"></NavigationButton>
    </div>

    <p class="details-info-text">
        Aquesta rosa s'ha generat a partir del treball en codi obert de Katherine Crowson (
        <a href="https://github.com/crowsonkb" target="_blank" class="text-link">https://github.com/crowsonkb</a>) basat
        en el mètode VQGAN+CLIP original (
        <a href="https://twitter.com/advadnoun" target="_blank" class="text-link">https://twitter.com/advadnoun</a>).
        <br>
        Aquesta rosa es pot distribuir lliurement sense fer-ne un ús comercial sota la llicència
        <a href="https://creativecommons.org/licenses/by-nc-nd/4.0/" target="_blank" class="text-link">Creative Commons
            CC BY-NC-ND 4.0</a>.
    </p>
</div>

<style>

    #image-info-container {
        display: flex;
        gap: 1em;
    }

    .selected-image {
        width: min(400px, 90vw);
        max-width: 400px
    }

    @media (max-width: 1000px) {
        #image-info-container {
            flex-direction: column;
        }
    }

</style>